export const copyToClipboard = async (text?: string) => {
    if (text && navigator.clipboard) {
        await navigator.clipboard.writeText(text?.trim() ?? "");
    }
};